/**
 * Login page UI text translations
 * These are display labels, NOT secrets or API keys
 */
export const loginTranslations = {
  en: {
    title: 'Welcome Back',
    subtitle: 'Sign in to your English Passion account',
    emailLabel: 'Email Address',
    passwordLabel: 'Password',
    forgotPasswordLink: 'Forgot Password?',
    signInButton: 'Sign In',
    signingInButton: 'Signing In...',
    noAccountText: "Don't have an account?",
    createAccountLink: 'Create Account',
    orContinueText: 'Or continue as',
    guestText: 'Guest'
  },
  ko: {
    title: '다시 오신 것을 환영합니다',
    subtitle: 'English Passion 계정에 로그인하세요',
    emailLabel: '이메일 주소',
    passwordLabel: '비밀번호',
    forgotPasswordLink: '비밀번호를 잊으셨나요?',
    signInButton: '로그인',
    signingInButton: '로그인 중...',
    noAccountText: '계정이 없으신가요?',
    createAccountLink: '계정 만들기',
    orContinueText: '또는',
    guestText: '게스트로 계속하기'
  },
  ja: {
    title: 'おかえりなさい',
    subtitle: 'English Passionアカウントにサインイン',
    emailLabel: 'メールアドレス',
    passwordLabel: 'パスワード',
    forgotPasswordLink: 'パスワードを忘れた方',
    signInButton: 'サインイン',
    signingInButton: 'サインイン中...',
    noAccountText: 'アカウントをお持ちでない方',
    createAccountLink: 'アカウント作成',
    orContinueText: 'または',
    guestText: 'ゲストとして続ける'
  }
};
